/**
 * promesa-cert-block.js  v1.1
 * Promesa Joyería — Bloque de certificación de la piedra
 * Tema: Showcase | Shopify
 *
 * Muestra un bloque de especificaciones (certificado, corte, quilates,
 * color, claridad, dureza) que se actualiza en vivo según la Piedra y
 * los Quilates seleccionados. Layout de 2 columnas fijo en cualquier
 * ancho de pantalla (grid-auto-flow: dense en el CSS evita huecos).
 *
 * ADITIVO: no modifica promesa-variant-selector.js.
 *
 * ── INTEGRACIÓN ────────────────────────────────────────────────
 *   1. Subir este archivo a: Tienda → Temas → Assets
 *   2. Subir promesa-cert-block.liquid a: Snippets
 *   3. En layout/theme.liquid, junto a
 *      {%- render 'promesa-variant-selector' -%}, agregar:
 *        {%- render 'promesa-cert-block' -%}
 *
 * ── VERIFICACIÓN ────────────────────────────────────────────────
 *   Consola del navegador en la página de producto:
 *        promesaCertDiagnostico()
 */

(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // A. CONFIGURACIÓN
  // ═══════════════════════════════════════════════════════════════════

  // Umbral de color para Moissanita: por debajo → G, desde este valor → D
  var UMBRAL_COLOR_MOISSANITA = 1.3;

  // Corte "Ideal" para diamante lab solo aplica a corte redondo.
  // Para ocultarlo en un producto de otro corte, poner en el <body>:
  // data-promesa-corte="fantasia"
  function esCorteRedondo() {
    var attr = document.body.getAttribute('data-promesa-corte');
    return !attr || attr.toLowerCase() === 'redondo';
  }

  // ═══════════════════════════════════════════════════════════════════
  // B. IMÁGENES — inyectadas desde promesa-cert-block.liquid
  //    (los .js puros no procesan Liquid; la URL debe llegar por acá)
  // ═══════════════════════════════════════════════════════════════════

  function urlGrabado() {
    var a = window.PROMESA_CERT_ASSETS;
    return (a && a.grabado) || '';
  }

  function urlCertificado(piedra) {
    var a = window.PROMESA_CERT_ASSETS;
    return (a && a.certificado && a.certificado[piedra]) || '';
  }

  // ═══════════════════════════════════════════════════════════════════
  // C. GETTERS — mismos selectores que promesa-variant-selector.js
  // ═══════════════════════════════════════════════════════════════════

  function getPiedraSelect()   { return document.querySelector('select[aria-label="Piedra"]'); }
  function getQuilatesSelect() { return document.querySelector('select[aria-label="Quilates"]'); }

  function ctSeleccionado() {
    var sel = getQuilatesSelect();
    if (!sel || !sel.value) return null;
    var m = sel.value.match(/^([\d.]+)/);
    return m ? m[1] : null;
  }

  function piedraSeleccionada() {
    var sel = getPiedraSelect();
    return sel ? sel.value : 'Moissanita';
  }

  // ═══════════════════════════════════════════════════════════════════
  // D. CONTENIDO POR TIPO DE PIEDRA
  // ═══════════════════════════════════════════════════════════════════

  function specsMoissanita(ct) {
    var esG = ct === null || parseFloat(ct) < UMBRAL_COLOR_MOISSANITA;
    return {
      filas: [
        { label: 'Certificado', valor: 'GRI' },
        { label: 'Quilates',    valor: (ct || '—') + ' ct' },
        { label: 'Corte',       valor: 'Excelente' },
        { label: 'Color',       valor: (esG ? 'G' : 'D') + ' · Incoloro' },
        { label: 'Claridad',    valor: 'VVS1' },
        { label: 'Dureza',      valor: '9.25 Mohs' },
      ],
      nota: null,
    };
  }

  function specsDiamante(ct) {
    var filas = [{ label: 'Certificado', valor: 'IGI' }];
    if (esCorteRedondo()) filas.push({ label: 'Corte', valor: 'Ideal' });
    filas.push(
      { label: 'Quilates', valor: (ct || '—') + ' ct' },
      { label: 'Color',    valor: 'D – E · Incoloro' },
      { label: 'Claridad', valor: 'VVS (1–2)' },
      { label: 'Dureza',   valor: '10 Mohs' }
    );
    return {
      filas: filas,
      nota: 'Seleccionamos el mejor diamante disponible de este tamaño o superior, jamás uno más pequeño.',
    };
  }

  // ═══════════════════════════════════════════════════════════════════
  // E. RENDER
  // ═══════════════════════════════════════════════════════════════════

  function svgGrabadoPlaceholder() {
    return (
      '<svg viewBox="0 0 72 48" width="72" height="48" aria-hidden="true">' +
        '<rect width="72" height="48" fill="#F5EDD4"/>' +
        '<circle cx="36" cy="24" r="11" fill="none" stroke="#7A5C10" stroke-width="1.4" opacity="0.5"/>' +
        '<path d="M30 24l4 4 8-8" fill="none" stroke="#7A5C10" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" opacity="0.55"/>' +
      '</svg>'
    );
  }

  function svgCertificadoPlaceholder() {
    return (
      '<svg viewBox="0 0 34 68" width="34" height="68" aria-hidden="true">' +
        '<rect width="34" height="68" fill="#F5EDD4"/>' +
        '<rect x="7" y="10" width="20" height="26" rx="1.5" fill="none" stroke="#7A5C10" stroke-width="1.2" opacity="0.55"/>' +
        '<line x1="11" y1="17" x2="23" y2="17" stroke="#7A5C10" stroke-width="1" opacity="0.4"/>' +
        '<line x1="11" y1="21" x2="23" y2="21" stroke="#7A5C10" stroke-width="1" opacity="0.4"/>' +
        '<line x1="11" y1="25" x2="19" y2="25" stroke="#7A5C10" stroke-width="1" opacity="0.4"/>' +
        '<circle cx="17" cy="31" r="3.2" fill="none" stroke="#7A5C10" stroke-width="1" opacity="0.5"/>' +
      '</svg>'
    );
  }

  function filaHTML(f) {
    var sub = f.subnota
      ? '<div class="promesa-cert__subnota">' + f.subnota + '</div>'
      : '';
    return (
      '<div class="promesa-cert__row">' +
        '<span class="promesa-cert__label">' + f.label + '</span>' +
        '<span class="promesa-cert__value">' + f.valor + '</span>' +
      '</div>' + sub
    );
  }

  function render() {
    var contenedor = document.getElementById('promesa-cert-block');
    if (!contenedor) return;

    var piedra = piedraSeleccionada();
    var ct = ctSeleccionado();
    var data = piedra === 'Diamante lab' ? specsDiamante(ct) : specsMoissanita(ct);

    var filasHTML = data.filas.map(filaHTML).join('');
    var notaExtra = data.nota
      ? '<p class="promesa-cert__nota-extra">' + data.nota + '</p>'
      : '';

    var fotoGrabado = urlGrabado();
    var imgGrabadoHTML = fotoGrabado
      ? '<img src="' + fotoGrabado + '" alt="Ejemplo de inscripción láser" />'
      : svgGrabadoPlaceholder();

    var fotoCert = urlCertificado(piedra);
    var imgCertHTML = fotoCert
      ? '<img src="' + fotoCert + '" alt="Carátula del certificado ' + (piedra === 'Diamante lab' ? 'IGI' : 'GRI') + '" />'
      : svgCertificadoPlaceholder();

    contenedor.innerHTML =
      '<div class="promesa-cert__rows">' + filasHTML + '</div>' +
      notaExtra +
      '<div class="promesa-cert__grabado">' +
        '<div class="promesa-cert__grabado-media">' + imgGrabadoHTML + '</div>' +
        '<p class="promesa-cert__grabado-texto">' +
          '✦ Inscripción láser en la piedra, coincide con el certificado.' +
          '<span class="promesa-cert__grabado-caption">' +
            (fotoGrabado ? 'Ejemplo ilustrativo' : 'Imagen de referencia') +
          '</span>' +
        '</p>' +
        '<div class="promesa-cert__cert-cover">' + imgCertHTML + '</div>' +
      '</div>';
  }

  // ═══════════════════════════════════════════════════════════════════
  // F. INSERTAR EL CONTENEDOR — justo después del selector de Quilates
  // ═══════════════════════════════════════════════════════════════════

  function insertarContenedor() {
    if (document.getElementById('promesa-cert-block')) return true;

    var quilatesSel = getQuilatesSelect();
    if (!quilatesSel) return false;

    var anclaje = quilatesSel.closest('.pretty-select') || quilatesSel.parentElement;
    if (!anclaje) return false;

    var div = document.createElement('div');
    div.id = 'promesa-cert-block';
    div.className = 'promesa-cert';
    anclaje.insertAdjacentElement('afterend', div);
    return true;
  }

  // ═══════════════════════════════════════════════════════════════════
  // G. DIAGNÓSTICO
  // ═══════════════════════════════════════════════════════════════════

  window.promesaCertDiagnostico = function () {
    console.group('%c🔍 Promesa — Diagnóstico bloque de certificación', 'font-weight:bold;font-size:14px;');
    console.log('Piedra select:', getPiedraSelect());
    console.log('Quilates select:', getQuilatesSelect());
    console.log('Contenedor insertado:', document.getElementById('promesa-cert-block'));
    console.log('Piedra actual:', piedraSeleccionada(), '| ct actual:', ctSeleccionado());
    console.log('Corte redondo activo:', esCorteRedondo());
    console.log('URL grabado:', urlGrabado() || '(placeholder)');
    console.log('URL certificado Moissanita:', urlCertificado('Moissanita') || '(placeholder)');
    console.log('URL certificado Diamante lab:', urlCertificado('Diamante lab') || '(placeholder)');
    console.groupEnd();
  };

  // ═══════════════════════════════════════════════════════════════════
  // H. INICIALIZACIÓN
  // ═══════════════════════════════════════════════════════════════════

  function init() {
    if (!insertarContenedor()) {
      setTimeout(init, 300);
      return;
    }
    render();

    var piedraSel = getPiedraSelect();
    var quilatesSel = getQuilatesSelect();
    if (piedraSel)   piedraSel.addEventListener('change', render);
    if (quilatesSel) quilatesSel.addEventListener('change', render);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

}());
